import React from 'react'
import Card from '@mui/material/Card'
import avatar from '../../../../assests/images/PatientApoointment/avatar.png'
import CardContent from '@mui/material/CardContent'
import CheckMark from '../../../../assests/images/checkMark.png'
import Calendar from '../../../../assests/images/calendarNew.png'
import TimeNew from '../../../../assests/images/timeNew.png'
import { Button, CircularProgress, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { Skeleton } from '@mui/material'
import { nameAvatar } from '../../../utils'
import { specialityOfPrivider } from '../../../../containers/AppointmentList/utils'
import moment from 'moment'

const ReviewAppointment = ({
    appointmentDetails,
    reviewAppointmentLoader,
    selctedProviderDetails,
    isMobileView,
    isFirstTime
}) => {
    const userInfo = useSelector((state) => state.login.userData)
    const amdPatientDetails =  useSelector((state) => state?.patient?.amdPatientDetails)
    return (
        <div className="booking_boxes">
            <div
                style={{
                    display: 'flex',
                    gap: 10,
                    alignItems: 'center',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}>
                <img src={CheckMark} />
                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                    <Typography className="step-headers">
                        Your appointment has been booked successfully!
                    </Typography>
                </div>
                <Typography className="congrats_sub_heading" style={{marginTop: '5px'}}>
                    If there are any issues with your appointment, a care coordinator will contact
                    you to adjust the date or time if needed.
                </Typography>
                {/* <Typography className='congrats_sub_heading'>
                    A care coordinator will contact you to confirm your appointment.
                </Typography> */}
            </div>

            <div
                className="body card-raw"
                style={{
                    display: 'flex',
                    alignItem: 'center',
                    gap: isMobileView ? '0px' : '37px',
                    flexDirection: isMobileView ? 'column' : 'unset',
                }}>
                <div className="body">
                    <Typography className="appo_details_title congrats_title">
                        Appointment Details
                    </Typography>
                    <div
                        className="provider_card"
                        style={{
                            width: !isMobileView && '400px',
                            height: !isMobileView && '218px',
                            border: '1px solid #C4C4C4',
                            borderRadidus: '5px',
                        }}>
                        <div className="card_content">
                            {reviewAppointmentLoader ? (
                                <div className="provider_card_content">
                                    <div className="left_section">
                                        <Skeleton variant="circular" width={60} height={60} />
                                        <div className="about_doctor" style={{ gap: 10 }}>
                                            <span style={{ display: 'flex', gap: 10 }}>
                                                <Skeleton variant="rounded" width={150} />
                                                <Skeleton variant="rounded" width={50} />
                                            </span>
                                            <Skeleton variant="rounded" width={200} />
                                            <Skeleton variant="rounded" width={200} />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="provider_card_content" style={{
                                    display: !isMobileView && 'unset',
                                    justifyContent: !isMobileView && 'unset',
                                    alignItems: !isMobileView && 'unset',
                                }}>
                                    <div className="left_section" style={{ width: '100%' }}>
                                        <div>
                                            {/* <img src={avatar} alt="avatar" /> */}
                                            {selctedProviderDetails?.avatar ? (
                                                <img
                                                    style={{
                                                        borderRadius: '80px',
                                                        border: '2px solid #D8D8D8',
                                                    }}
                                                    alt="avatar"
                                                    src={`data:image/jpeg;base64,${selctedProviderDetails?.avatar}`}
                                                    height={63}
                                                    width={60}
                                                />
                                            ) : (
                                                //  from backend we recieved first name on last_name key and last name on first_name key for that reason we display flip
                                                nameAvatar(
                                                    `${selctedProviderDetails?.last_name} ${selctedProviderDetails?.first_name} `,
                                                )
                                            )}
                                        </div>
                                        <div className="about_doctor" style={{ width: '100%' }}>
                                            <div>
                                                <Typography
                                                    className="name"
                                                    style={{
                                                        fontFamily: 'Inter',
                                                        color: '#252525',
                                                    }}>
                                                    {appointmentDetails?.providerName || 'N/A'}
                                                </Typography>
                                                <Typography
                                                    className="practice"
                                                    style={{
                                                        fontFamily: 'Inter',
                                                        color: '#252525',
                                                        fontWeight: '400'
                                                    }}>
                                                    {specialityOfPrivider(
                                                        selctedProviderDetails?.specialities,
                                                    ) || 'N/A'}
                                                </Typography>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="more_info_holder" style={{ marginTop: '27px' }}>
                                        <span
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                            }}>
                                            <img src={Calendar} />
                                            <Typography
                                                className="practice"
                                                style={{
                                                    fontFamily: 'Inter',
                                                    fontWeight: '400',
                                                    color: '#252525',
                                                }}>
                                                {moment(
                                                    appointmentDetails?.date,
                                                    'MMMM Do, YYYY',
                                                ).format('dddd, MMMM D, YYYY') || 'N/A'}
                                            </Typography>
                                        </span>
                                        <span
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                                marginTop: '27px',
                                            }}>
                                            <img src={TimeNew} />
                                            <Typography
                                                className="practice"
                                                style={{
                                                    fontFamily: 'Inter',
                                                    fontWeight: '400',
                                                    color: '#252525',
                                                }}>
                                                {appointmentDetails?.startTime ||
                                                appointmentDetails?.endTime
                                                    ? `${appointmentDetails?.startTime} - ${appointmentDetails?.endTime}`
                                                    : '----'}
                                            </Typography>
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="body">
                    <Typography className="appo_details_title congrats_title">
                        Patient Information
                    </Typography>
                    <div
                        className="provider_card"
                        style={{
                            width: !isMobileView && '400px',
                            height: !isMobileView && '218px',
                            border: '1px solid #C4C4C4',
                            borderRadidus: '5px',
                        }}>
                        <div className="card_content">
                            <div className="provider_card_content">
                                <div style={{ marginBottom: 0 }} className="left_section">
                                    <div className="about_doctor more_info_holder">
                                        <Typography
                                            className="name"
                                            style={{
                                                fontFamily: 'Inter',
                                                color: '#252525',
                                                marginTop: '10px',
                                                fontWeight: '500'
                                            }}>
                                            {amdPatientDetails?.first_name ||
                                            amdPatientDetails?.last_name
                                                ? `${amdPatientDetails?.first_name} ${amdPatientDetails.last_name}`
                                                : 'N/A'}
                                        </Typography>

                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                                marginTop: '20px',
                                            }}>
                                            <svg
                                                className='d-md-none'
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14"
                                                height="15"
                                                viewBox="0 0 10 11"
                                                fill="none">
                                                <path
                                                    d="M8.53807 9.36143C7.52297 10.3819 4.9449 9.4425 2.77565 7.26455C0.606399 5.0866 -0.325267 2.49206 0.689831 1.47159L1.74108 0.414761C1.92464 0.230236 2.22221 0.230236 2.40855 0.414761L3.48205 1.49395C3.6656 1.67848 3.6656 1.97763 3.48205 2.16495L2.75062 2.90026C2.18606 3.46781 2.68109 4.91046 3.88531 6.12106C5.08952 7.33165 6.55237 7.85727 7.11693 7.28971L7.84836 6.55441C8.03191 6.36988 8.32949 6.36988 8.51582 6.55441L9.58932 7.6336C9.77288 7.81813 9.77288 8.11728 9.58932 8.3046L8.53807 9.36143Z"
                                                    fill="#667689"
                                                />
                                                <path
                                                    d="M8.34316 9.16245C8.30979 9.196 8.27363 9.22675 8.23748 9.25751C8.27919 9.22396 8.22357 9.2659 8.20688 9.27708C8.18464 9.29106 8.15961 9.30783 8.13736 9.32181C8.09564 9.34698 8.05393 9.36655 8.00943 9.38612C8.05393 9.36655 8.00387 9.38891 7.98718 9.3945C7.95659 9.40569 7.92599 9.41687 7.89262 9.42526C7.84534 9.43924 7.79528 9.45322 7.74522 9.4616C7.72019 9.4672 7.69516 9.46999 7.66735 9.47558C7.66457 9.47558 7.62286 9.48118 7.65345 9.47838C7.68682 9.47279 7.61729 9.48117 7.61173 9.48397C7.49493 9.49515 7.37812 9.49515 7.26131 9.48956C6.72456 9.4644 6.13219 9.25751 5.61769 9.00868C4.19655 8.31811 2.94784 7.20537 1.99671 5.94724C1.56286 5.37689 1.1735 4.75342 0.900957 4.08801C0.784151 3.80284 0.689594 3.50928 0.62841 3.21012C0.57835 2.97248 0.55332 2.7544 0.570007 2.4888C0.572788 2.46084 0.572788 2.43288 0.575569 2.40772C0.57835 2.39094 0.57835 2.37137 0.581131 2.3546C0.581131 2.36019 0.575569 2.39653 0.581131 2.36298C0.589474 2.30707 0.600599 2.25115 0.614504 2.19803C0.625629 2.1505 0.639534 2.10018 0.656221 2.05265C0.659002 2.04426 0.689593 1.96877 0.678469 1.99394C0.670126 2.0163 0.697937 1.952 0.70628 1.94081C0.728529 1.89888 0.750777 1.85694 0.778588 1.8178C0.784151 1.80661 0.828648 1.74511 0.811962 1.77027C0.798056 1.78984 0.839773 1.73672 0.850897 1.72554C0.881489 1.69199 0.912081 1.66123 0.942673 1.63048C1.22634 1.3453 1.51002 1.06013 1.79647 0.772156C1.87434 0.693873 1.96611 0.562469 2.0857 0.562469C2.20251 0.562469 2.2915 0.688281 2.36937 0.766565C2.66139 1.06013 2.9534 1.35369 3.24542 1.64725C3.34276 1.74511 3.40116 1.85414 3.29548 1.97716C3.18701 2.10297 3.05908 2.21481 2.94228 2.33223C2.66139 2.61461 2.34991 2.86903 2.2776 3.28561C2.16913 3.91467 2.43612 4.5633 2.74482 5.09451C3.1592 5.80745 3.73767 6.42533 4.39123 6.92578C4.9391 7.34516 5.58432 7.70582 6.27681 7.7897C6.53545 7.82045 6.79965 7.80088 7.04161 7.69184C7.19457 7.62195 7.31137 7.51011 7.43096 7.39269C7.5867 7.23612 7.74522 7.07676 7.90096 6.92019C7.98996 6.83073 8.09564 6.67416 8.23748 6.70491C8.34594 6.72728 8.44328 6.86707 8.51837 6.94256C8.67967 7.10472 8.83819 7.26408 8.9995 7.42624C9.12465 7.55205 9.24701 7.67786 9.37494 7.80367C9.47228 7.89873 9.50287 8.01057 9.40275 8.1224C9.15246 8.40198 8.87157 8.6564 8.60736 8.92201C8.50724 8.9975 8.42381 9.07858 8.34316 9.16245C8.09008 9.41687 8.48221 9.81388 8.73529 9.55666C8.99393 9.29665 9.25536 9.03384 9.514 8.77383C9.60577 8.68157 9.70033 8.5949 9.78655 8.49984C10.073 8.1923 10.0702 7.73937 9.78376 7.43183C9.52234 7.14945 9.23867 6.88385 8.96612 6.60985C8.87157 6.5148 8.78257 6.41415 8.67967 6.32468C8.37097 6.05908 7.93712 6.08144 7.6451 6.35823C7.39203 6.59867 7.15563 6.86148 6.90255 7.10472C6.89143 7.1159 6.8803 7.12429 6.8664 7.13547C6.86918 7.13268 6.90255 7.11031 6.87752 7.12708C6.85806 7.14106 6.83859 7.15225 6.81912 7.16343C6.80243 7.17182 6.74125 7.19978 6.78853 7.1802C6.76072 7.19139 6.73569 7.19978 6.70788 7.20816C6.68007 7.21655 6.64947 7.22214 6.62166 7.22773C6.56882 7.23892 6.64391 7.22773 6.59107 7.23053C6.52433 7.23612 6.46036 7.23612 6.39639 7.23333C6.26846 7.22773 6.16278 7.20537 6.01817 7.16343C5.87077 7.12149 5.72615 7.06837 5.5871 7.00407C4.84733 6.66018 4.20768 6.1094 3.68761 5.48313C3.44287 5.18398 3.22595 4.85687 3.0563 4.51018C2.98399 4.36201 2.92559 4.21103 2.87831 4.05446C2.85885 3.99016 2.84216 3.92306 2.82825 3.85876C2.81157 3.77488 2.806 3.74692 2.80044 3.68541C2.79488 3.61831 2.7921 3.55121 2.79766 3.48411C2.80044 3.45616 2.80044 3.43099 2.80322 3.40303C2.79766 3.45616 2.81157 3.3611 2.81713 3.34991C2.82269 3.32475 2.83103 3.30238 2.8366 3.27722C2.84216 3.26045 2.86441 3.21012 2.84494 3.25206C2.85606 3.2269 2.86997 3.20173 2.88387 3.17937C2.89222 3.16259 2.93393 3.10947 2.90056 3.14861C3.00346 3.0228 3.13139 2.91097 3.24542 2.79634C3.38447 2.65655 3.52631 2.51676 3.66536 2.37417C3.91844 2.11136 3.98241 1.70317 3.7627 1.39842C3.67371 1.27541 3.5569 1.17196 3.44844 1.06292C3.27879 0.892377 3.10914 0.721831 2.9395 0.551286C2.83103 0.442248 2.72257 0.327619 2.61133 0.221377C2.33044 -0.0442268 1.91049 -0.0805727 1.60457 0.165461C1.49333 0.254927 1.39877 0.363965 1.29865 0.461819C1.12901 0.632365 0.962141 0.800115 0.792494 0.970661C0.519947 1.24465 0.264086 1.49348 0.125032 1.86533C-0.0668635 2.37696 -0.0112415 2.96409 0.113908 3.48411C0.280773 4.17189 0.595037 4.82611 0.962141 5.42442C1.85487 6.88105 3.12027 8.15595 4.56644 9.0618C5.16437 9.43644 5.81515 9.75796 6.50208 9.9313C7.02214 10.0627 7.60895 10.1242 8.12345 9.9369C8.35428 9.85302 8.56008 9.73 8.73529 9.55666C8.99115 9.30504 8.59902 8.91082 8.34316 9.16245Z"
                                                    fill="#667689"
                                                />
                                            </svg>
                                            <Typography
                                                className="practice"
                                                style={{ fontFamily: 'Inter', color: '#252525',fontWeight: '400' }}>
                                                {amdPatientDetails?.phone || '----'}
                                            </Typography>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                                marginTop: '20px',
                                            }}>
                                            <svg
                                                // className='d-md-none'
                                                style={{ marginTop: 3 }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="21"
                                                viewBox="0 0 11 14"
                                                fill="none">
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M0.95063 2.12471L5.11391 5.84301C5.21914 5.9375 5.35681 5.98993 5.49968 5.98993C5.64255 5.98993 5.78022 5.9375 5.88545 5.84301L10.0487 2.12471C9.9705 2.08694 9.88441 2.06732 9.79716 2.06738H1.2022C1.11495 2.06731 1.02886 2.08692 0.95063 2.12471ZM0.7116 8.41424C0.658655 8.32791 0.630744 8.22912 0.63086 8.12846V2.62613C0.630744 2.52548 0.658655 2.42669 0.7116 2.34036L4.11192 5.3773L0.7116 8.41424ZM4.35216 5.59241L4.89578 6.07791C5.06055 6.22575 5.27605 6.30778 5.49968 6.30778C5.72331 6.30778 5.93881 6.22575 6.10358 6.07791L6.6472 5.59241L10.0487 8.62988C9.9705 8.66767 9.88441 8.68729 9.79716 8.68721H1.2022C1.11495 8.68729 1.02886 8.66767 0.95063 8.62988L4.35216 5.59241ZM6.88744 5.3773L10.2878 2.34036C10.3407 2.42669 10.3686 2.52548 10.3685 2.62613V8.12846C10.3686 8.22912 10.3407 8.32791 10.2878 8.41424L6.88744 5.3773Z"
                                                    fill="#667689"
                                                />
                                            </svg>
                                            <Typography
                                                className="practice"
                                                style={{ fontFamily: 'Inter', color: '#252525',fontWeight: '400' }}>
                                                {amdPatientDetails?.email || '----'}
                                            </Typography>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                                marginTop: '20px',
                                            }}>
                                            <svg
                                                width="18"
                                                height="23"
                                                viewBox="0 0 18 23"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M12.4098 5.07614C12.1305 5.07614 11.8984 4.83455 11.8984 4.54373V3.1242C11.8984 2.83338 12.1305 2.5918 12.4098 2.5918C12.6891 2.5918 12.9212 2.83338 12.9212 3.1242V4.54373C12.9212 4.83455 12.6891 5.07614 12.4098 5.07614Z"
                                                    fill="#767676"
                                                />
                                                <path
                                                    d="M5.59144 5.07614C5.31211 5.07614 5.08008 4.83455 5.08008 4.54373V3.1242C5.08008 2.83338 5.31211 2.5918 5.59144 2.5918C5.87077 2.5918 6.10281 2.83338 6.10281 3.1242V4.54373C6.10281 4.83455 5.87077 5.07614 5.59144 5.07614Z"
                                                    fill="#767676"
                                                />
                                                <path
                                                    d="M16.3294 7.56087V6.67376C16.3294 5.20431 15.184 4.01172 13.7726 4.01172H4.22674C2.81538 4.01172 1.66992 5.20431 1.66992 6.67376V7.56087H16.3294Z"
                                                    fill="#767676"
                                                />
                                                <path
                                                    d="M1.66992 8.625V15.1916C1.66992 16.661 2.81538 17.8536 4.22674 17.8536H13.772C15.1833 17.8536 16.3288 16.661 16.3288 15.1916V8.625H1.66992ZM5.59081 15.1916C5.21559 15.1916 4.90878 14.8721 4.90878 14.4815C4.90878 14.0908 5.21559 13.7714 5.59081 13.7714C5.96603 13.7714 6.27285 14.0908 6.27285 14.4815C6.27285 14.8721 5.96603 15.1916 5.59081 15.1916ZM5.59081 11.6417C5.21559 11.6417 4.90878 11.3223 4.90878 10.9316C4.90878 10.541 5.21559 10.2215 5.59081 10.2215C5.96603 10.2215 6.27285 10.541 6.27285 10.9316C6.27285 11.3223 5.96603 11.6417 5.59081 11.6417ZM8.99969 15.1916C8.62447 15.1916 8.31765 14.8721 8.31765 14.4815C8.31765 14.0908 8.62447 13.7714 8.99969 13.7714C9.3749 13.7714 9.68172 14.0908 9.68172 14.4815C9.68172 14.8721 9.3749 15.1916 8.99969 15.1916ZM8.99969 11.6417C8.62447 11.6417 8.31765 11.3223 8.31765 10.9316C8.31765 10.541 8.62447 10.2215 8.99969 10.2215C9.3749 10.2215 9.68172 10.541 9.68172 10.9316C9.68172 11.3223 9.3749 11.6417 8.99969 11.6417ZM12.4086 15.1916C12.0333 15.1916 11.7265 14.8721 11.7265 14.4815C11.7265 14.0908 12.0333 13.7714 12.4086 13.7714C12.7838 13.7714 13.0906 14.0908 13.0906 14.4815C13.0906 14.8721 12.7838 15.1916 12.4086 15.1916ZM12.4086 11.6417C12.0333 11.6417 11.7265 11.3223 11.7265 10.9316C11.7265 10.541 12.0333 10.2215 12.4086 10.2215C12.7838 10.2215 13.0906 10.541 13.0906 10.9316C13.0906 11.3223 12.7838 11.6417 12.4086 11.6417Z"
                                                    fill="#767676"
                                                />
                                            </svg>
                                            <Typography
                                                className="practice"
                                                style={{
                                                    fontFamily: 'Inter',
                                                    color: '#252525',
                                                    fontWeight: '400'
                                                }}>
                                                {amdPatientDetails?.dob || '----'}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="confirmPagelastText">
                <a href={isFirstTime ? 'https://pp-wfe-100.advancedmd.com/160918/account/register' : 'https://pp-wfe-100.advancedmd.com/160918/account/logon'} target='_blank' rel="noopener noreferrer">
                    <span
                        style={{
                            color: '#4C67B2',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}>
                        {isFirstTime
                            ? 'Sign up for your Patient Portal'
                            : 'Access your Patient Portal'}
                    </span>
                </a>{' '}
                to view upcoming appointments or update your information.
            </div>
            <div className="confirmPagelastText" style={{ fontWeight: '500' , paddingBottom: '10px'}}>
                If you need assistance please call us at (855) 446-8628.
            </div>
        </div>
    )
}

export default ReviewAppointment
